import { useTranslation } from 'react-i18next';
import ButtonList from '../ButtonList';
import { useRef } from 'react';
import { useRestContext } from 'components/form/RestInputContext';
import { useParams } from 'react-router-dom';
import FailedQCModal from '../ModalConfirm/FailedQCModal';
import PassQCConfirmModal from '../ModalConfirm/PassQCConfirmModal';
import { Button, Card } from 'antd';
import CancelModal from '../ModalConfirm/CancelModal';
import {
  APPROVED_SUB_STATUS,
  RETURN_CHANNEL,
  RETURN_METHOD,
} from 'constants/ordersReturn';

export default function ApprovedScreen() {
  const { t } = useTranslation();
  const params = useParams();
  const refFailedModal = useRef<{ open: () => void }>();
  const refPassModal = useRef<{ open: () => void }>();
  const refCancelModal = useRef<{ open: () => void }>();
  const { record } = useRestContext();

  const conditionShowCancelBtn = () => {
    if (record?.isMarketPlace) return false;

    const isOfflineReturn =
      record?.returnType === RETURN_CHANNEL['OFFLINE'].value;
    const isOnlineDropOff =
      record?.returnType === RETURN_CHANNEL['ONLINE'].value &&
      record?.returnMethod === RETURN_METHOD['DROP_OFF'].value;
    const isOnlinePickupWaiting =
      record?.returnType === RETURN_CHANNEL['ONLINE'].value &&
      record?.returnMethod === RETURN_METHOD['PICKUP'].value &&
      record?.shippingStatus ===
        APPROVED_SUB_STATUS['WAITING_FOR_PICKUP'].value;

    return isOfflineReturn || isOnlineDropOff || isOnlinePickupWaiting;
  };

  return (
    <>
      <Card title="QA/QC">
        <ButtonList
          btnCancelText={t('common.button.failQC')}
          btnOkText={t('common.button.passQC')}
          onOk={() => refPassModal.current.open()}
          onCancel={() => refFailedModal.current.open()}
          isShowButton={
            (record?.isMarketPlace &&
              record?.order?.statusOms === 'DELIVERY_SUCCESS') ||
            !record?.isMarketPlace
          }
          extendChildren={
            <>
              {conditionShowCancelBtn() && (
                <Button
                  onClick={() => refCancelModal.current.open()}
                  className="btn-light btn-h-32 flex-1"
                >
                  {t('common.button.cancel')}
                </Button>
              )}
            </>
          }
        />
      </Card>
      <CancelModal
        id={record?.id || params?.id}
        ref={refCancelModal}
        initValue={{
          cancelReason: record?.cancelReason,
        }}
      />
      <FailedQCModal id={record?.id || params?.id} ref={refFailedModal} />
      <PassQCConfirmModal id={record?.id || params?.id} ref={refPassModal} />
    </>
  );
}
